<p-toast [style]="{marginTop: '80px'}"></p-toast>
<div *ngIf="loadingTeam" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>
<h5>{{lbl_int_coord_organiz_chart}}</h5>

<p-tree [value]="team" layout="horizontal" selectionMode="single" (onNodeSelect)="onNodeSelect($event)"
    *ngIf="typeChart == '1'"></p-tree>

<p-organizationChart [value]="team" selectionMode="single" (onNodeSelect)="onNodeSelect($event)"
    [(selection)]="selectedNode" styleClass="company" *ngIf="typeChart == '2'" [preserveSpace]="false"
    [responsive]="true" style="width: 400;">
    <ng-template let-node pTemplate="person">
        <div class="node-header p-corner-top">{{node.label}}</div>
        <div class="node-content">

        </div>
    </ng-template>
    <ng-template let-node pTemplate="department">
        {{node.label}}
    </ng-template>
</p-organizationChart>



<p-dialog [(visible)]="displayDetailTeam" [modal]="true" [style]="{width: '30vw'}" [baseZIndex]="1000"
    [draggable]="false" [resizable]="false">

    <ng-template pTemplate="header">
        <h4>{{selectedNode.label}}</h4>
    </ng-template>

    <ng-template pTemplate="body">
        <div class="p-grid layout-invoice-content">
            <div class="p-col-12">
                <div class="card" *ngIf="selectedNode.data != null">
                    <div class="p-col-12">
                        <p-panel>
                            <div class="p-text-center p-text-bold">{{selectedNode.data.guide.name}}
                                {{selectedNode.data.guide.lastName}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.data.emailInst}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.data.guide.email}}</div>
                            <div class="p-text-center">{{selectedNode.data.guide.mobPhon}}</div>
                            <div class="p-text-center">{{selectedNode.data.address.tel1}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.data.address.city}} -
                                {{selectedNode.data.address.state}}- {{selectedNode.data.address.country}}</div>
                        </p-panel>
                    </div>
                </div>

                <div class="card" *ngIf="selectedNode.data == null">
                    <div class="p-col-12">
                        <p-panel>
                            <div class="p-text-center p-text-bold">{{selectedNode.coord.guide.name}}
                                {{selectedNode.coord.guide.lastName}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.coord.emailInst}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.coord.guide.email}}</div>
                            <div class="p-text-center">{{selectedNode.coord.guide.mobPhon}}</div>
                            <div class="p-text-center">{{selectedNode.coord.address.tel1}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.coord.address.city}} -
                                {{selectedNode.coord.address.state}} - {{selectedNode.coord.address.country}}</div>

                            <div class="p-text-center"></div>

                            <div class="p-text-center p-text-bold">{{selectedNode.secretary.guide.name}}
                                {{selectedNode.secretary.guide.lastName}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.secretary.emailInst}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.secretary.guide.email}}</div>
                            <div class="p-text-center">{{selectedNode.secretary.guide.mobPhon}}</div>
                            <div class="p-text-center">{{selectedNode.secretary.address.tel1}}</div>
                            <div class="p-text-center p-text-italic">{{selectedNode.secretary.address.city}} -
                                {{selectedNode.secretary.address.state}}- {{selectedNode.secretary.address.country}}
                            </div>



                        </p-panel>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>



    <p class="m-0"></p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayDetailTeam=false" label="Ok" class="p-button-text"></p-button>
        <!--p-button icon="pi pi-times" (click)="displayDetailTeam=false" label="No"></p-button-->
    </ng-template>
</p-dialog>